import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

import { TResultsBot, TResultsBotItem } from '@core/interfaces/TResultsItem';

import { ConfirmationModalComponent } from '../../components/modals/confirmation-modal/confirmation-modal.component';
import { ResultsService } from '@shared/services/results.service';
import { isNotNullAndDefined } from '@shared/utils/isNotNullAndDefined';

@Component({
    selector: 'app-result-item',
    templateUrl: './result-item.component.html',
    styleUrls: ['./result-item.component.scss'],
    standalone: true,
    imports: [MatTooltip, MatIcon, MatCheckbox, ReactiveFormsModule, FormsModule]
})
export class ResultItemComponent implements OnChanges {
  @Input() public item: TResultsBot = {} as TResultsBot;
  @Input() public canBeSelected = false;
  @Input() public itemsSelection: TResultsBotItem[] = [];
  @Output() public deletedItemEmiter: EventEmitter<string> = new EventEmitter<string>();
  @Output() public selectedItemEmiter: EventEmitter<void> = new EventEmitter<void>();
  public isSelected = false;
  public displayName = '';

  constructor(
    private _resultsService: ResultsService,
    public dialog: MatDialog
  ) {}

  ngOnChanges(): void {
    // Cache the display name to avoid recalculating on every change detection
    this.displayName = this.calculateDisplayName(this.item);
    // this.canDeleteItem =
    //   allowedToDeleteContentItems.includes(this.item.__type) && !this.canBeSelected;
    // this.isSelected = this.itemsSelection.map(item => item._id).includes(this.item._id);
  }

  public hasSufix(item: TResultsBotItem): boolean {
    return isNotNullAndDefined(item.sufix);
  }

  public toggleSelection(): void {
    this.selectedItemEmiter.emit();
  }

  public openDeleteItemModal(item: TResultsBot): void {
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      data: { text: `Are you sure you want to delete ${item.name}?` },
    });
    const dialogSubscription = dialogRef.componentInstance.actionCallback.subscribe(() => {
      dialogRef.close();
      this._resultsService.cancelableDeleteConversation(item);
      this.deletedItemEmiter.emit(item._id!);
      dialogSubscription.unsubscribe();
    });
  }

  public needsTooltip(title: string): boolean {
    if (title) {
      return title.length > 25;
    }
    return false;
  }

  private calculateDisplayName(item: TResultsBot): string {
    if (!item.name || item.name === undefined) {
      return 'New chat';
    }

    // Check if name looks like JSON (starts with { and contains "type":"quiz")
    if (item.name.trim().startsWith('{') && item.name.includes('"type":"quiz"')) {
      try {
        const parsed = JSON.parse(item.name);
        if (parsed.type === 'quiz' && parsed.data?.question) {
          // Extract question text and truncate if too long
          const question = parsed.data.question;
          return question.length > 60
            ? `Quiz: ${question.substring(0, 57)}…`
            : `Quiz: ${question}`;
        }
      } catch (e) {
        // If parsing fails, return original name
        return item.name;
      }
    }

    return item.name;
  }

  public getDisplayName(item: TResultsBot): string {
    // Return cached display name to avoid recalculating on every change detection
    item; // to avoid unused parameter lint error
    return this.displayName;
  }
}
